import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { useDebounce } from "use-debounce"
import PlayerInterface from "../../../interfaces/Player.interface"
import { getAllPlayers, searchPlayer } from "../../../services/players.services"
import Content from "../../../components/Content"
import PlayerTable from "../../../components/PlayerTable"
import Loader from "../../../components/Loader"

const PlayersPage = () => {
    const [players, setPlayers] = useState<PlayerInterface[]>([])
    const [loading, setLoading] = useState<boolean>(true)

    const [search, setSearch] = useState<string>("")
    const [result, setResult] = useState<PlayerInterface[]>([])

    const [searchValue] = useDebounce(search, 1000)


    const handleSearch: React.ChangeEventHandler<HTMLInputElement> = (event) => setSearch(event.target.value)

    useEffect(() => {
        getAllPlayers()
            .then((res) => {
                setPlayers(res.data.payload.players)
            })
            .catch(() => {
                toast.error("Ha ocurrido un error :/")
            })
            .finally(() => setLoading(false))
    }, [])

    useEffect(() => {
        if (searchValue.length > 0) {
            setLoading(true)
            searchPlayer({ search: searchValue })
                .then((res) => setResult(res.data.payload.result))
                .catch((error) => toast.error(error.response.data.message))
                .finally(() => setLoading(false))
        }
    }, [searchValue])

    return (

        <Content className="flex flex-col gap-10">
            <input
                className="px-5 h-[45px] border rounded outline-none"
                type="text"
                name="name"
                onChange={handleSearch}
                placeholder="Buscar por nombre"
                autoComplete="off"
            />
            <div className="relative overflow-x-auto">
                {loading && <Loader />}
                {!loading && search.length > 0 && <PlayerTable players={result} />}
                {!loading && search.length === 0 && <PlayerTable players={players} />}
            </div>
        </Content>

    )
}

export default PlayersPage